

















import Component from 'vue-class-component'
import LoginContainer from '@/components/authentication/login-container/LoginContainer.component'
import {ExpiredPwdAuthenticationRequest, PortalType} from '@payroll/optimus-common'
import {Action, Getter} from 'vuex-class'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import FeedbackComponent from '../../base/FeedbackComponent'

@Component({
    components: {
        LoginContainer
    }
})
export default class PasswordExpiredComponent extends FeedbackComponent {

    private expiredAuth: ExpiredPwdAuthenticationRequest = {} as ExpiredPwdAuthenticationRequest
    private newPasswordRepeat: string = ''
    private tooltipMessage: string = ''

    @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string
    @Getter('idNumber', StoreNamespace.AUTHENTICATION) idNumber!: string
    @Action('changeExpiredPassword', StoreNamespace.AUTHENTICATION) changeExpiredPassword: any

    mounted() {
        this.expiredAuth.managingCompany = this.mngCompanyName
        this.expiredAuth.portalType = PortalType.BACKOFFICE
        this.expiredAuth.idNumber = this.idNumber
        this.tooltipMessage = ('' + this.$t('password_instructions_title'))
            + '</br>' + ('' + this.$t('password_instructions_text1'))
            + '</br>' + ('' + this.$t('password_instructions_text2'))
            + '</br>' + ('' + this.$t('password_instructions_text3'))
            + '</br>' + ('' + this.$t('password_instructions_text4'))
            + '</br>' + ('' + this.$t('password_instructions_text5'))
            + '</br>' + ('' + this.$t('password_instructions_text6'))
    }

    onLogin() {
        if (this.expiredAuth.password === this.newPasswordRepeat) {
            this.changeExpiredPassword({requestBody: this.expiredAuth, requestorCallback: this})
        } else {
            this.serverErrorMessages.pop(); //this prevent the validation message to overflow from the container
            this.serverErrorMessages.push(this.$t('passwords_not_matched').toString())
        }
    }

    onSuccess(data?: any, requestName?: string, message?: string): void {
        this.$router.push({name: 'lobby'})
    }
}
